module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-4 20c0 1.106-.894 2-2 2H8c-1.106 0-2-.894-2-2v-8c0-1.106.894-2 2-2h16c1.106 0 2 .894 2 2v8zm-3-8h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/toggle.js
// module id = 1452
// module chunks = 14